import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome to ARIALOK");
      navigate("/account");
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-24">
      <p className="overline">Sign up</p>
      <h1 className="mt-2 font-serif text-4xl text-[#1e392a] tracking-tight">Join the ritual.</h1>
      <form onSubmit={submit} className="mt-10 space-y-5">
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8a8d86]">Full name</Label>
          <Input
            data-testid="register-name-input"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="bg-white border-[#e6e2d8] mt-2 h-11"
          />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8a8d86]">Email</Label>
          <Input
            data-testid="register-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-white border-[#e6e2d8] mt-2 h-11"
          />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-[#8a8d86]">Password</Label>
          <Input
            data-testid="register-password-input"
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-white border-[#e6e2d8] mt-2 h-11"
          />
          <p className="text-xs text-[#8a8d86] mt-1.5">At least 6 characters.</p>
        </div>
        {error && (
          <p data-testid="register-error" className="text-sm text-[#c36a4f]">
            {error}
          </p>
        )}
        <Button
          type="submit"
          data-testid="register-submit-btn"
          disabled={loading}
          className="w-full h-12 rounded-full bg-[#1e392a] hover:bg-[#14251b] text-white"
        >
          {loading ? "Creating account…" : "Create account"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-[#8a8d86]">
        Already have an account?{" "}
        <Link data-testid="register-to-login-link" to="/login" className="text-[#c36a4f] hover:underline">
          Sign in
        </Link>
      </p>
    </div>
  );
}
